import React from 'react';
import { Modal } from 'react-bootstrap';
import { Typography } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import { Button } from '../Button';

interface propsModalNotificacao {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function ModalMensagens(props: propsModalNotificacao) {
    let history = useHistory();

    function handleCloseModal() {
        props.setShowModal(false);
    }

    return (
        <Modal
            show={props.showModal}
            onHide={() => handleCloseModal()}
            dialogClassName="modal-90w"
            animation={true}
            centered={true}
            size={"lg"}
            style={{ overflow: 'hidden' }}
        >

            <Modal.Header closeButton className="modal-header-adicionar-itens-pedido">
                <Modal.Title className="detalhe-adicionar-itens-titulo-modal">
                    <Typography className="detalhe-adicionar-itens-texto-titulo">Mensagens</Typography>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body
                style={{ overflow: 'hidden' }}>
                <div className="modal-container-additens-area">
                    <label className={"modal-additens-title"} htmlFor="modal-additens-title"><b>Não há nenhuma mensagem no momento.</b></label>
                    <div className="modal-search-product-area">
                        <div className="modal-additens-searchfield">

                        </div>
                    </div>
                    <div className="modal-derivation-table-area">

                    </div>

                    <div className="modal-additens-footer-itens-area">
                        <div className="modal-additens-footer-info-area">
                        </div>
                        <div className="modal-additens-footer-addbotoes-area">
                            <Button onClick={() => handleCloseModal()} classBtn={"btn-footer-novo-pedido color-red"}>Fechar</Button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}